import { Controller } from 'stimulus';
import Rails from '@rails/ujs';

export default class extends Controller {
	static targets = ["dropdown", "sortBy", "sortByForm"]

	sortBy() {
		this.sortByFormTarget.submit
	}

	selectDropdown() {
		let newUrl = this.dropdownTarget.value
		window.location.href = newUrl
	}
}
